function initVimeoFacade() {
  const facades = document.querySelectorAll('.vimeo-facade');

  facades.forEach(facade => {
    // Find the lazy attribute and get the video ID from it
    const lazyVideoId = facade.getAttribute('data-lazy-vimeo-id');
    
    if (!lazyVideoId) return; // If no ID, do nothing

    // Now, set the *real* data attribute that our click listener will use.
    // The theme's script has already run and missed this.
    facade.setAttribute('data-vimeo-id', lazyVideoId);

    // Set up the click listener as before
    facade.addEventListener('click', function (event) {
      event.preventDefault();
      const videoId = this.dataset.vimeoId;

      if (!videoId) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      
      this.innerHTML = '';
      this.appendChild(iframe);
    }, { once: true });
  });
}

// These lines at the bottom remain the same
document.addEventListener('DOMContentLoaded', initVimeoFacade);
document.addEventListener('shopify:section:load', initVimeoFacade);